import { trigger, transition, animate, style } from '@angular/animations';

export const Blur = trigger('blur', [
    transition(':enter', [
        style({ 'backdrop-filter': 'blur(0px)', opacity: 0 }),
        animate('0.3s cubic-bezier(0.5, 0, 0.1, 1)', style({ 'backdrop-filter': 'blur(1px)', opacity: 1 })),
    ]),
    transition(':leave', [animate('0.3s cubic-bezier(0.5, 0, 0.1, 1)', style({ 'backdrop-filter': 'blur(0px)', opacity: 0 }))]),
]);
